export function LayoutLine(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      //width="14"
      //height="6562"
      viewBox="0 0 14 6562"
      fill="none"
    >
      <path
        d="M7.21671 6550.84L7.21678 0M7.00943 6561C8.6327 6561 13.8217 6552.63 12.8886 6551.68C11.9555 6550.73 2.15258 6550.64 1.13028 6551.68C0.107989 6552.72 5.38746 6561 7.00943 6561Z"
        stroke="url(#paint0_linear_278_556)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_278_556"
          x1="6.81999"
          y1="-0.000312423"
          x2="6.81999"
          y2="6561"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function DesignIcon(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="133"
      height="132"
      viewBox="0 0 133 132"
      fill="none"
    >
      <path
        d="M32.1854 62.7V26.73C32.1854 15.345 41.4254 6.10498 52.8104 6.10498H63.0404C74.4254 6.10498 83.6654 15.345 83.6654 26.73V103.785C83.6654 112.365 90.5954 119.13 99.0104 119.13C107.59 119.13 114.355 112.2 114.355 103.785V93.555"
        stroke="url(#paint0_linear_261_523)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M57.9257 98.67C57.9257 112.86 46.3757 124.41 32.1857 124.41C17.9957 124.41 6.44568 112.86 6.44568 98.67V47.19C6.44568 41.58 11.0657 36.96 16.6757 36.96H47.5307C53.1407 36.96 57.7607 41.58 57.7607 47.19V98.67H57.9257Z"
        stroke="url(#paint1_linear_261_523)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.44568 62.7H57.9257"
        stroke="url(#paint2_linear_261_523)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.751 26.73V78.21H104.126V26.73H114.356H124.751Z"
        stroke="url(#paint3_linear_261_523)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M104.126 26.73L114.356 6.10498L124.586 26.73"
        stroke="url(#paint4_linear_261_523)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M124.751 78.045H104.126V83.16C104.126 88.77 108.746 93.39 114.356 93.39C119.966 93.39 124.586 88.77 124.586 83.16V78.045H124.751Z"
        stroke="url(#paint5_linear_261_523)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_261_523"
          x1="72.0379"
          y1="6.10498"
          x2="72.0379"
          y2="119.13"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_523"
          x1="31.4135"
          y1="36.96"
          x2="31.4135"
          y2="124.41"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_523"
          x1="31.4135"
          y1="62.7"
          x2="31.4135"
          y2="63.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_523"
          x1="114.129"
          y1="26.73"
          x2="114.129"
          y2="78.21"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_523"
          x1="114.049"
          y1="6.10498"
          x2="114.049"
          y2="26.73"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_523"
          x1="114.129"
          y1="78.045"
          x2="114.129"
          y2="93.39"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CodingIcon(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="133"
      height="132"
      viewBox="0 0 133 132"
      fill="none"
    >
      <path
        d="M84.824 65.1748L99.839 80.1898L84.824 95.2048"
        stroke="url(#paint0_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M47.0397 65.175L32.0247 80.19L47.0397 95.205"
        stroke="url(#paint1_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M73.4401 65.175L58.425 95.37"
        stroke="url(#paint2_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09985 30.03C8.09985 24.42 12.5549 19.965 18.1649 19.965H113.7C119.31 19.965 123.765 24.42 123.765 30.03V100.485C123.765 106.095 119.31 110.55 113.7 110.55H18.1649C12.5549 110.55 8.09985 106.095 8.09985 100.485V30.03Z"
        stroke="url(#paint3_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.09985 45.045H123.765"
        stroke="url(#paint4_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5898 31.35C26.2498 31.35 26.9098 31.845 26.9098 32.67C26.9098 33.33 26.4148 33.99 25.5898 33.99C24.9298 33.99 24.2698 33.495 24.2698 32.67C24.4348 31.845 24.9298 31.35 25.5898 31.35Z"
        stroke="url(#paint5_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M40.769 31.3496C41.429 31.3496 42.089 31.8446 42.089 32.6696C42.089 33.3296 41.594 33.9896 40.769 33.9896C40.109 33.9896 39.449 33.4946 39.449 32.6696C39.449 31.8446 40.109 31.3496 40.769 31.3496Z"
        stroke="url(#paint6_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M55.7851 31.35C56.4451 31.35 57.1051 31.845 57.1051 32.67C57.1051 33.33 56.6101 33.99 55.7851 33.99C55.1251 33.99 54.4651 33.495 54.4651 32.67C54.6301 31.845 55.1251 31.35 55.7851 31.35Z"
        stroke="url(#paint7_linear_261_539)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_261_539"
          x1="92.1063"
          y1="65.1748"
          x2="92.1063"
          y2="95.2048"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_539"
          x1="39.3069"
          y1="65.175"
          x2="39.3069"
          y2="95.205"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_539"
          x1="65.7073"
          y1="65.175"
          x2="65.7073"
          y2="95.37"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_539"
          x1="64.1974"
          y1="19.965"
          x2="64.1974"
          y2="110.55"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_539"
          x1="64.1974"
          y1="45.045"
          x2="64.1974"
          y2="46.045"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_539"
          x1="25.5502"
          y1="31.35"
          x2="25.5502"
          y2="33.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_539"
          x1="40.7294"
          y1="31.3496"
          x2="40.7294"
          y2="33.9896"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_539"
          x1="55.7455"
          y1="31.35"
          x2="55.7455"
          y2="33.99"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function ResearchIcon(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="133"
      height="132"
      viewBox="0 0 133 132"
      fill="none"
    >
      <path
        d="M71.2885 78.045H119.963C122.768 78.045 125.079 75.735 125.079 72.93V11.55C125.079 8.745 122.768 6.435 119.963 6.435H58.5835"
        stroke="url(#paint0_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.0083 60.06V75.405"
        stroke="url(#paint1_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M43.2386 124.08L45.8786 93.39H58.5836V75.405C58.5836 61.215 47.1986 49.83 33.0086 49.83C18.8186 49.83 7.43359 61.38 7.43359 75.405V93.39H20.3036L22.9436 124.08H43.2386Z"
        stroke="url(#paint2_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M38.9485 24.255C42.9085 24.255 46.8685 23.43 50.6635 21.945C49.6735 14.355 44.0635 8.25 36.4735 6.765C29.0485 5.28 21.4585 8.745 17.4985 15.345C23.1085 21.12 30.8635 24.255 38.9485 24.255Z"
        stroke="url(#paint3_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M33.0084 42.24C42.9084 42.24 50.9934 34.155 50.9934 24.255C50.9934 14.355 42.9084 6.435 33.0084 6.435C23.1084 6.435 15.0234 14.355 15.0234 24.255C15.0234 34.155 23.1084 42.24 33.0084 42.24Z"
        stroke="url(#paint4_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M68.8135 26.895L81.6835 39.765L68.8135 52.635"
        stroke="url(#paint5_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M94.3887 42.24H114.849"
        stroke="url(#paint6_linear_261_557)"
        strokeWidth="3.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_261_557"
          x1="90.8336"
          y1="6.43499"
          x2="90.8336"
          y2="78.045"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_557"
          x1="33.4933"
          y1="60.06"
          x2="33.4933"
          y2="75.405"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_557"
          x1="32.2413"
          y1="49.83"
          x2="32.2413"
          y2="124.08"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_557"
          x1="33.5836"
          y1="6.42448"
          x2="33.5836"
          y2="24.255"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_557"
          x1="32.4689"
          y1="6.435"
          x2="32.4689"
          y2="42.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_557"
          x1="75.0554"
          y1="26.895"
          x2="75.0554"
          y2="52.635"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_557"
          x1="104.312"
          y1="42.24"
          x2="104.312"
          y2="43.24"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CustomsIcons1(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
    >
      <mask
        id="mask0_261_383"
        style={{ maskType: "luminance" }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="-1"
        width="80"
        height="81"
      >
        <path d="M80 -0.000732422H0V79.9993H80V-0.000732422Z" fill="white" />
      </mask>
      <g mask="url(#mask0_261_383)">
        <path
          d="M44.375 55.0149L44.7625 55.2368"
          stroke="url(#paint0_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.7625 55.2368C46.2281 56.0836 50.1593 58.3493 53.8718 60.4899"
          stroke="url(#paint1_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.0969 60.5461L40.1594 60.5836"
          stroke="url(#paint2_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.1594 60.5836C41.3688 61.2805 44.0594 62.8336 46.9344 64.4899"
          stroke="url(#paint3_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.375 55.0149L44.1594 54.8899C44.1594 54.8899 44.2407 54.9368 44.375 55.0149Z"
          stroke="url(#paint4_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.7156 60.3243C39.8125 60.3805 39.9406 60.4555 40.1 60.5462"
          stroke="url(#paint5_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.0625 64.4899L32.35 64.0774"
          stroke="url(#paint6_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1281 60.4899L25.9187 60.3712"
          stroke="url(#paint7_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.065 64.4899H33.0625"
          stroke="url(#paint8_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M53.8718 60.4899L44.7625 55.2368"
          stroke="url(#paint9_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.3338 56.218H60.3313"
          stroke="url(#paint10_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.6438 60.2867L39.7157 60.3242"
          stroke="url(#paint11_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.9875 67.9055L40 68.4899"
          stroke="url(#paint12_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.7156 60.3243C39.6906 60.3118 39.6656 60.2961 39.6469 60.2836"
          stroke="url(#paint13_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.6438 60.2868L39.4875 60.1962C39.4875 60.1962 39.5438 60.2274 39.6438 60.2868Z"
          stroke="url(#paint14_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.7626 55.2368C44.6032 55.1461 44.475 55.0711 44.3782 55.0149"
          stroke="url(#paint15_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.0968 60.5462L39.7156 60.3243"
          stroke="url(#paint16_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.9344 64.4899L40.1594 60.5836"
          stroke="url(#paint17_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.1594 60.5836C40.1375 60.5711 40.1188 60.5586 40.0969 60.5461"
          stroke="url(#paint18_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.3969 64.7555C49.05 65.7149 49.6094 67.8242 48.6469 69.493L48.6032 69.568C47.6751 71.1742 45.6157 71.7274 44.0063 70.7992L40.0032 68.4899"
          stroke="url(#paint19_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.3313 56.218L47.625 48.8899L60.325 56.2118C60.325 56.2118 60.3281 56.2118 60.3313 56.2149"
          stroke="url(#paint20_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.4688 60.8336C54.2719 60.7211 54.0719 60.6055 53.875 60.4899"
          stroke="url(#paint21_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.4687 60.8336L53.8718 60.4899"
          stroke="url(#paint22_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.3969 64.7555C47.3969 64.7555 47.3907 64.7524 47.3907 64.7492C47.2407 64.6617 47.0907 64.5742 46.9407 64.4899"
          stroke="url(#paint23_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.9376 50.2961C64.7657 50.7743 65.5 51.1993 66.1125 51.5524C67.7719 52.5086 68.3376 54.6243 67.3688 56.2961L67.3251 56.3711C66.3969 57.9774 64.3375 58.5305 62.7282 57.6024L60.3313 56.2211"
          stroke="url(#paint24_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M47.3968 64.7555L46.9343 64.4899"
          stroke="url(#paint25_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M60.3344 56.218C61.9875 57.1774 62.5531 59.2899 61.5969 60.943C60.6406 62.5993 58.5187 63.168 56.8594 62.2118L54.4688 60.8336"
          stroke="url(#paint26_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.4687 60.8336C56.125 61.7899 56.6844 63.9024 55.7187 65.5711L55.675 65.6461C54.7469 67.2524 52.6875 67.8055 51.0781 66.8774L47.3969 64.7524"
          stroke="url(#paint27_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.0625 50.2961C16.0094 50.1274 15.9469 49.9618 15.9 49.793L9.8938 46.3305"
          stroke="url(#paint28_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.6843 25.9337L27.6906 29.3962L29.7531 28.5899C33.075 27.293 36.7375 27.3493 39.9999 28.6649"
          stroke="url(#paint29_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.25 44.9993L8.50625 48.7274L9.89375 46.3305"
          stroke="url(#paint30_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.4375 16.2493L23.0719 23.5336L9.8938 46.3305"
          stroke="url(#paint31_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6656 56.2211C18.0125 57.1805 17.4468 59.293 18.4031 60.9461C19.3593 62.6024 21.4812 63.1711 23.1406 62.2149L25.0312 61.1243"
          stroke="url(#paint32_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.9968 70.7993L36.05 70.7649"
          stroke="url(#paint33_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.1282 60.4899L26.2313 60.4337"
          stroke="url(#paint34_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6656 56.218C19.6656 56.218 19.6688 56.2149 19.6719 56.2149"
          stroke="url(#paint35_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.9343 64.4899H46.9368"
          stroke="url(#paint36_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.05 70.7649L37.3719 70.0055"
          stroke="url(#paint37_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.2313 60.4337C26.8875 60.0555 26.9782 60.0024 26.1282 60.493"
          stroke="url(#paint38_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.525 60.8399L25.0344 61.1212"
          stroke="url(#paint39_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7687 56.1586L19.6719 56.2149"
          stroke="url(#paint40_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6719 56.2149L19.7687 56.1586"
          stroke="url(#paint41_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40 68.4899L37.3718 70.0055"
          stroke="url(#paint42_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7688 56.1586L20.3594 55.818L19.7688 56.1586Z"
          stroke="url(#paint43_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6657 56.218L17.2688 57.6024C15.6594 58.5305 13.6 57.9805 12.6719 56.3711L12.6282 56.2961C11.6625 54.6243 12.2282 52.5086 13.8844 51.5524C14.4969 51.1993 15.2313 50.7743 16.0594 50.2961"
          stroke="url(#paint44_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.525 60.8399L26.1281 60.4899"
          stroke="url(#paint45_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6656 56.218L19.6719 56.2149"
          stroke="url(#paint46_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.525 60.8399C25.525 60.8399 25.5313 60.8336 25.5344 60.8336C25.775 60.6961 25.9625 60.5867 26.1281 60.4899"
          stroke="url(#paint47_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M58.3156 25.9337L52.3094 29.3962L50.2469 28.5899C46.925 27.293 43.2625 27.3493 40 28.6649"
          stroke="url(#paint48_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.525 60.8399C23.875 61.7993 23.3187 63.9055 24.2844 65.5743L24.3281 65.6493C25.2562 67.2555 27.3156 67.8087 28.925 66.8805L30.9062 65.7368"
          stroke="url(#paint49_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.9968 70.7993C34.3875 71.7274 32.3281 71.1774 31.4 69.568L31.3562 69.493C30.3937 67.8243 30.9531 65.718 32.6031 64.7587"
          stroke="url(#paint50_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.6094 64.7524L33.0625 64.4899"
          stroke="url(#paint51_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.0625 64.4899C36.3812 62.5774 33.3 64.3524 33.3 64.3524L33.0625 64.4899Z"
          stroke="url(#paint52_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.0625 64.4899C32.9188 64.5742 32.7813 64.6524 32.6125 64.7492C32.6125 64.7492 32.6125 64.7492 32.6094 64.7492"
          stroke="url(#paint53_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.3501 39.0024L46.7001 40.3586"
          stroke="url(#paint54_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M44.3501 39.0024C45.0813 39.4243 45.8595 39.8743 46.7001 40.3586"
          stroke="url(#paint55_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.9376 50.2962C59.4157 47.6868 52.1094 43.4774 46.7001 40.3555"
          stroke="url(#paint56_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M54.1407 39.4711C50.3501 39.4711 47.0188 39.2618 44.3501 39.0024"
          stroke="url(#paint57_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M40.0001 28.668C39.4063 28.9087 38.8251 29.1743 38.2626 29.4993L35.7282 30.9587L31.3157 33.468C29.7938 34.3337 28.6876 35.7837 28.2594 37.4805L26.5626 44.1899C26.2876 45.2743 27.1094 46.3274 28.2313 46.3274C30.2938 46.3274 32.1594 45.1055 32.9844 43.218L34.3063 40.1899L37.5219 38.0524C37.5219 38.0524 40.0907 38.5868 44.3501 38.9993"
          stroke="url(#paint58_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M63.9375 50.2961C63.9906 50.1274 64.0531 49.9618 64.1 49.793L70.1062 46.3305"
          stroke="url(#paint59_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9031 65.7336L32.6093 64.7524"
          stroke="url(#paint60_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M32.6 64.7586C32.6 64.7586 32.6031 64.7555 32.6062 64.7524"
          stroke="url(#paint61_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M70.1062 46.3305L71.4937 48.7274L78.75 44.9993"
          stroke="url(#paint62_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M69.5625 16.2493L56.9281 23.5336L70.1062 46.3305"
          stroke="url(#paint63_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6656 56.218V56.2205"
          stroke="url(#paint64_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6656 56.218L19.7594 56.1649C19.7594 56.1649 19.7656 56.1618 19.7656 56.1586"
          stroke="url(#paint65_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.7687 56.1586C21.4218 55.1993 21.9843 53.0868 21.0312 51.4336C20.075 49.7774 17.9531 49.2086 16.2937 50.1649"
          stroke="url(#paint66_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M19.6656 56.2211L17.9594 57.2055"
          stroke="url(#paint67_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.5625 55.1274C23.2219 54.1712 25.3406 54.7399 26.3 56.3962C27.0563 57.7024 26.85 59.2868 25.9219 60.3712"
          stroke="url(#paint68_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M25.9188 60.3712C25.6719 60.6618 25.3813 60.9212 25.0312 61.1243"
          stroke="url(#paint69_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9025 65.7336C30.9025 65.7336 30.9025 65.7336 30.9 65.7361"
          stroke="url(#paint70_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9031 65.7336C31.5812 65.3399 32.0656 64.7493 32.35 64.0774"
          stroke="url(#paint71_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.4313 59.7399C29.0906 58.7836 31.2094 59.3524 32.1688 61.0086C32.7313 61.9836 32.7563 63.1149 32.35 64.0805"
          stroke="url(#paint72_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.0656 64.4899L32.6 64.7586"
          stroke="url(#paint73_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.9 65.7368L32.6 64.7587"
          stroke="url(#paint74_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.9968 70.7993L36.05 70.7649"
          stroke="url(#paint75_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M36.05 70.7649L37.3719 70.0055"
          stroke="url(#paint76_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M38.9876 67.9055C39.2188 67.0493 39.1219 66.1055 38.6407 65.2743C37.6844 63.618 35.5625 63.0493 33.9032 64.0055L33.0657 64.4899"
          stroke="url(#paint77_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M37.3718 70.0055C38.2 69.5274 38.7562 68.7618 38.9875 67.9055"
          stroke="url(#paint78_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.5687 71.043L35.9969 70.7993"
          stroke="url(#paint79_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M27.4312 59.7399L26.2312 60.4336"
          stroke="url(#paint80_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.0344 59.393L27.4313 59.7399"
          stroke="url(#paint81_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M21.5625 55.1274L20.3594 55.818"
          stroke="url(#paint82_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22.1625 54.7805L21.5625 55.1274"
          stroke="url(#paint83_linear_261_383)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_383"
          x1="44.5629"
          y1="55.0149"
          x2="44.5629"
          y2="55.2368"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_383"
          x1="49.1805"
          y1="55.2368"
          x2="49.1805"
          y2="60.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_383"
          x1="40.1272"
          y1="60.5461"
          x2="40.1272"
          y2="60.5836"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_383"
          x1="43.4453"
          y1="60.5836"
          x2="43.4453"
          y2="64.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_383"
          x1="44.264"
          y1="54.8899"
          x2="44.264"
          y2="55.0149"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_383"
          x1="39.902"
          y1="60.3243"
          x2="39.902"
          y2="60.5462"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_383"
          x1="32.6955"
          y1="64.0774"
          x2="32.6955"
          y2="64.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_383"
          x1="26.0202"
          y1="60.3712"
          x2="26.0202"
          y2="60.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_261_383"
          x1="33.0637"
          y1="64.4899"
          x2="33.0637"
          y2="65.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_261_383"
          x1="49.1805"
          y1="55.2368"
          x2="49.1805"
          y2="60.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_261_383"
          x1="60.3325"
          y1="56.218"
          x2="60.3325"
          y2="57.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_261_383"
          x1="39.6787"
          y1="60.2867"
          x2="39.6787"
          y2="60.3242"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_261_383"
          x1="39.4786"
          y1="67.9055"
          x2="39.4786"
          y2="68.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_261_383"
          x1="39.6802"
          y1="60.2836"
          x2="39.6802"
          y2="60.3243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_261_383"
          x1="39.5633"
          y1="60.1962"
          x2="39.5633"
          y2="60.2868"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint15_linear_261_383"
          x1="44.5646"
          y1="55.0149"
          x2="44.5646"
          y2="55.2368"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint16_linear_261_383"
          x1="39.9005"
          y1="60.3243"
          x2="39.9005"
          y2="60.5462"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint17_linear_261_383"
          x1="43.4453"
          y1="60.5836"
          x2="43.4453"
          y2="64.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint18_linear_261_383"
          x1="40.1272"
          y1="60.5461"
          x2="40.1272"
          y2="60.5836"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint19_linear_261_383"
          x1="44.4239"
          y1="64.7555"
          x2="44.4239"
          y2="71.2496"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint20_linear_261_383"
          x1="53.7875"
          y1="48.8899"
          x2="53.7875"
          y2="56.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint21_linear_261_383"
          x1="54.163"
          y1="60.4899"
          x2="54.163"
          y2="60.8336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint22_linear_261_383"
          x1="54.1613"
          y1="60.4899"
          x2="54.1613"
          y2="60.8336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint23_linear_261_383"
          x1="47.162"
          y1="64.4899"
          x2="47.162"
          y2="64.7555"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint24_linear_261_383"
          x1="63.9742"
          y1="50.2961"
          x2="63.9742"
          y2="58.0527"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint25_linear_261_383"
          x1="47.1586"
          y1="64.4899"
          x2="47.1586"
          y2="64.7555"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint26_linear_261_383"
          x1="58.1515"
          y1="56.218"
          x2="58.1515"
          y2="62.676"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint27_linear_261_383"
          x1="51.6624"
          y1="60.8336"
          x2="51.6624"
          y2="67.3277"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint28_linear_261_383"
          x1="12.8856"
          y1="46.3305"
          x2="12.8856"
          y2="50.2961"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint29_linear_261_383"
          x1="30.5674"
          y1="25.9337"
          x2="30.5674"
          y2="29.3962"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint30_linear_261_383"
          x1="5.44222"
          y1="44.9993"
          x2="5.44222"
          y2="48.7274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint31_linear_261_383"
          x1="16.2852"
          y1="16.2493"
          x2="16.2852"
          y2="46.3305"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint32_linear_261_383"
          x1="21.3782"
          y1="56.2211"
          x2="21.3782"
          y2="62.6791"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint33_linear_261_383"
          x1="36.0226"
          y1="70.7649"
          x2="36.0226"
          y2="70.7993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint34_linear_261_383"
          x1="26.1782"
          y1="60.4337"
          x2="26.1782"
          y2="60.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint35_linear_261_383"
          x1="19.6687"
          y1="56.2149"
          x2="19.6687"
          y2="56.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint36_linear_261_383"
          x1="46.9355"
          y1="64.4899"
          x2="46.9355"
          y2="65.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint37_linear_261_383"
          x1="36.6912"
          y1="70.0055"
          x2="36.6912"
          y2="70.7649"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint38_linear_261_383"
          x1="26.4271"
          y1="60.1376"
          x2="26.4271"
          y2="60.493"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint39_linear_261_383"
          x1="25.2724"
          y1="60.8399"
          x2="25.2724"
          y2="61.1212"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint40_linear_261_383"
          x1="19.7189"
          y1="56.1586"
          x2="19.7189"
          y2="56.2149"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint41_linear_261_383"
          x1="19.7189"
          y1="56.1586"
          x2="19.7189"
          y2="56.2149"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint42_linear_261_383"
          x1="38.6465"
          y1="68.4899"
          x2="38.6465"
          y2="70.0055"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint43_linear_261_383"
          x1="20.0553"
          y1="55.818"
          x2="20.0553"
          y2="56.1586"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint44_linear_261_383"
          x1="15.7985"
          y1="50.2961"
          x2="15.7985"
          y2="58.0534"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint45_linear_261_383"
          x1="25.8175"
          y1="60.4899"
          x2="25.8175"
          y2="60.8399"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint46_linear_261_383"
          x1="19.6687"
          y1="56.2149"
          x2="19.6687"
          y2="56.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint47_linear_261_383"
          x1="25.8175"
          y1="60.4899"
          x2="25.8175"
          y2="60.8399"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint48_linear_261_383"
          x1="48.8831"
          y1="25.9337"
          x2="48.8831"
          y2="29.3962"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint49_linear_261_383"
          x1="27.2518"
          y1="60.8399"
          x2="27.2518"
          y2="67.3308"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint50_linear_261_383"
          x1="33.3642"
          y1="64.7587"
          x2="33.3642"
          y2="71.2503"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint51_linear_261_383"
          x1="32.8291"
          y1="64.4899"
          x2="32.8291"
          y2="64.7524"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint52_linear_261_383"
          x1="33.809"
          y1="63.6027"
          x2="33.809"
          y2="64.4899"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint53_linear_261_383"
          x1="32.8291"
          y1="64.4899"
          x2="32.8291"
          y2="64.7492"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint54_linear_261_383"
          x1="45.4898"
          y1="39.0024"
          x2="45.4898"
          y2="40.3586"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint55_linear_261_383"
          x1="45.4898"
          y1="39.0024"
          x2="45.4898"
          y2="40.3586"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint56_linear_261_383"
          x1="55.0603"
          y1="40.3555"
          x2="55.0603"
          y2="50.2962"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint57_linear_261_383"
          x1="49.0986"
          y1="39.0024"
          x2="49.0986"
          y2="39.4711"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint58_linear_261_383"
          x1="35.162"
          y1="28.668"
          x2="35.162"
          y2="46.3274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint59_linear_261_383"
          x1="66.9293"
          y1="46.3305"
          x2="66.9293"
          y2="50.2961"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint60_linear_261_383"
          x1="31.7306"
          y1="64.7524"
          x2="31.7306"
          y2="65.7336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint61_linear_261_383"
          x1="32.603"
          y1="64.7524"
          x2="32.603"
          y2="64.7586"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint62_linear_261_383"
          x1="74.2984"
          y1="44.9993"
          x2="74.2984"
          y2="48.7274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint63_linear_261_383"
          x1="63.3195"
          y1="16.2493"
          x2="63.3195"
          y2="46.3305"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint64_linear_261_383"
          x1="20.1506"
          y1="56.218"
          x2="20.1506"
          y2="56.2205"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint65_linear_261_383"
          x1="19.7141"
          y1="56.1586"
          x2="19.7141"
          y2="56.218"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint66_linear_261_383"
          x1="18.8163"
          y1="49.7007"
          x2="18.8163"
          y2="56.1586"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint67_linear_261_383"
          x1="18.7869"
          y1="56.2211"
          x2="18.7869"
          y2="57.2055"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint68_linear_261_383"
          x1="24.084"
          y1="54.6632"
          x2="24.084"
          y2="60.3712"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint69_linear_261_383"
          x1="25.4617"
          y1="60.3712"
          x2="25.4617"
          y2="61.1243"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint70_linear_261_383"
          x1="30.9012"
          y1="65.7336"
          x2="30.9012"
          y2="65.7361"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint71_linear_261_383"
          x1="31.6048"
          y1="64.0774"
          x2="31.6048"
          y2="65.7336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint72_linear_261_383"
          x1="29.9511"
          y1="59.2757"
          x2="29.9511"
          y2="64.0805"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint73_linear_261_383"
          x1="32.8258"
          y1="64.4899"
          x2="32.8258"
          y2="64.7586"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint74_linear_261_383"
          x1="31.7245"
          y1="64.7587"
          x2="31.7245"
          y2="65.7368"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint75_linear_261_383"
          x1="36.0226"
          y1="70.7649"
          x2="36.0226"
          y2="70.7993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint76_linear_261_383"
          x1="36.6912"
          y1="70.0055"
          x2="36.6912"
          y2="70.7649"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint77_linear_261_383"
          x1="35.9959"
          y1="63.5413"
          x2="35.9959"
          y2="67.9055"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint78_linear_261_383"
          x1="38.1554"
          y1="67.9055"
          x2="38.1554"
          y2="70.0055"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint79_linear_261_383"
          x1="35.7764"
          y1="70.7993"
          x2="35.7764"
          y2="71.043"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint80_linear_261_383"
          x1="26.8132"
          y1="59.7399"
          x2="26.8132"
          y2="60.4336"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint81_linear_261_383"
          x1="27.7238"
          y1="59.393"
          x2="27.7238"
          y2="59.7399"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint82_linear_261_383"
          x1="20.9429"
          y1="55.1274"
          x2="20.9429"
          y2="55.818"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint83_linear_261_383"
          x1="21.8535"
          y1="54.7805"
          x2="21.8535"
          y2="55.1274"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CustomsIcons2(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="70"
      height="80"
      viewBox="0 0 70 80"
      fill="none"
    >
      <path
        d="M61.5864 61.8026C62.7329 24.8112 56.6361 12.8306 51.2803 9.32477C48.6808 7.62298 46.3248 7.89043 45.1494 8.20217C43.0439 6.20908 34.9336 -0.765027 26.0481 0.730641C19.9956 1.74933 14.9788 6.4629 11.1357 14.7419C4.59603 28.8281 6.63681 34.6319 8.60776 40.2449C10.3589 45.2293 12.013 49.9361 6.62319 61.1877C6.42728 61.5948 6.50565 62.0547 6.77139 62.3818C2.69152 64.0461 0 66.8177 0 73.0968H2.25883C2.25883 72.659 2.27757 72.2485 2.30483 71.8515C2.66597 66.7019 5.3626 64.9405 10.0694 63.6322C11.4662 63.2438 13.03 62.8929 14.7727 62.5062C15.6193 62.3188 16.4966 62.1246 17.3978 61.9134C17.4199 61.9082 17.4404 61.9031 17.4625 61.898C18.0775 61.7549 19.0877 61.4977 20.2631 61.1417C20.2954 61.421 20.3431 61.7021 20.4045 61.9866C22.0722 69.7648 33.9166 78.8359 34.4583 79.2464C34.6593 79.3997 34.9012 79.4764 35.1414 79.4764C35.3816 79.4764 35.6218 79.3997 35.8245 79.2464C36.3492 78.8478 47.4968 70.3133 49.6995 62.7072C49.8442 62.2064 49.9482 61.7089 50.0095 61.2183C51.0674 61.5352 51.9651 61.7634 52.5324 61.898C53.5051 62.1297 54.4488 62.3426 55.3602 62.5471C55.8712 62.6612 56.3652 62.7736 56.8473 62.8826C57.7723 63.0939 58.6428 63.3017 59.4571 63.518C59.6427 63.8434 59.9698 64.0768 60.3701 64.0955L59.9579 63.6577C60.2969 63.7531 60.6274 63.8502 60.9476 63.9507C65.0258 65.2403 67.3613 67.0886 67.6952 71.8498C67.7224 72.2467 67.7412 72.6556 67.7412 73.0951H70C70 66.0034 66.5726 63.3988 61.5864 61.8009V61.8026ZM57.0909 60.6238C56.6838 60.5318 56.2732 60.4381 55.8576 60.3444C54.9564 60.1417 54.0212 59.9322 53.0587 59.7022C48.8869 58.7057 43.9178 56.8165 42.865 55.0193C42.5601 54.498 42.3812 53.7775 42.2858 52.9581C43.6452 51.9786 44.9143 50.6669 46.1187 49.006C47.2294 47.4745 48.289 45.6535 49.3111 43.5088C49.3502 43.4253 52.6107 35.7085 52.8526 33.1192L52.9259 33.1277C53.0553 32.0647 52.8288 31.1074 52.6618 30.4072C52.6107 30.196 52.5443 29.9115 52.5341 29.7888C52.5562 29.6832 52.563 29.5742 52.5528 29.4652C52.5204 29.058 51.6448 19.5202 44.7116 19.5202C41.7441 19.5202 38.3201 21.314 34.2402 25.0037C31.8519 27.1638 21.8371 29.0836 18.1797 29.6423C17.8526 29.6935 17.563 29.8825 17.3893 30.1653C17.2155 30.4464 17.1729 30.7905 17.2751 31.1056C17.4813 31.7445 17.8407 33.0136 18.2649 34.5075C19.4573 38.7135 20.4947 42.2942 21.0961 43.548C22.0671 45.5632 23.0653 47.3008 24.1096 48.7726C25.2594 50.3943 26.4672 51.6822 27.7499 52.6787C27.6682 53.6173 27.4808 54.4435 27.1418 55.0244C26.0754 56.8472 21.1114 58.7295 16.9481 59.7056C16.0333 59.9203 15.1424 60.1162 14.2838 60.307C13.8256 60.4075 13.3758 60.508 12.9295 60.6102C11.5122 60.9304 10.163 61.2558 8.90246 61.6374C14.3792 49.9259 12.536 44.6212 10.7388 39.5022C8.91609 34.315 7.03203 28.9507 13.185 15.6975C16.6925 8.13403 21.1438 3.85144 26.4144 2.95881C35.3628 1.4427 43.9553 10.1901 44.0404 10.2787C44.3726 10.6211 44.8956 10.7131 45.33 10.5172C45.4203 10.4763 47.5462 9.54111 50.1049 11.2565C54.0519 13.8987 60.4332 23.9237 59.3463 61.1672C58.6155 60.9798 57.8643 60.801 57.0909 60.6238ZM41.0815 51.0144C40.7135 51.2869 40.3353 51.522 39.9538 51.735C38.4853 52.5544 36.9113 52.9581 35.1874 52.9581C33.3238 52.9581 31.6305 52.4862 30.0565 51.5101C29.6698 51.2716 29.2933 50.9939 28.9202 50.6941C28.5182 50.3671 28.1213 50.0076 27.7346 49.6073C27.0362 48.8901 26.3599 48.0537 25.6989 47.0895C24.8199 45.8068 23.9682 44.306 23.1318 42.5685C22.5645 41.3896 21.2852 36.8771 20.4385 33.8926C20.2017 33.0613 19.9854 32.2964 19.8031 31.6695C23.4179 31.0562 32.9251 29.242 35.7563 26.6817C39.3524 23.4297 42.3642 21.7824 44.7133 21.7824C49.2106 21.7824 50.1662 28.4652 50.2889 29.5197C50.2343 29.9626 50.3434 30.4191 50.466 30.9336C50.6074 31.5264 50.7675 32.1976 50.6858 32.8585C50.6756 32.9403 50.6756 33.0204 50.6807 33.1004C50.3485 34.4922 47.5479 41.9143 47.2703 42.5463C46.3844 44.4065 45.4782 45.9942 44.5379 47.3365C43.7968 48.391 43.0337 49.2853 42.2416 50.0332C41.8617 50.3926 41.475 50.7265 41.0798 51.0178L41.0815 51.0144ZM47.3486 62.651C45.5106 67.8347 38.6659 74.1206 35.1431 76.9194C31.4823 74.0116 24.2356 67.339 22.7502 62.0479C22.5917 61.4841 22.4929 60.9338 22.4776 60.4075C25.164 59.4177 28.0208 57.9919 29.0906 56.1606C29.4466 55.5508 29.6817 54.8064 29.8333 53.9955C31.4789 54.8149 33.2488 55.2169 35.1857 55.2169C36.9965 55.2169 38.6591 54.8745 40.2093 54.1727C40.3626 54.9154 40.5841 55.5985 40.9145 56.1624C42.0099 58.0345 45.0302 59.4927 47.8001 60.4926C47.7694 61.1809 47.6127 61.9048 47.3469 62.6527L47.3486 62.651Z"
        fill="url(#paint0_linear_261_483)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_261_483"
          x1="33.95"
          y1="0.522152"
          x2="33.95"
          y2="79.4764"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function CustomsIcons3(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="70"
      viewBox="0 0 42 70"
      fill="none"
    >
      <g clipPath="url(#clip0_261_486)">
        <path
          d="M0 34.8993C0 25.8874 0 16.8756 0 7.86371C0.00250328 3.02155 3.04148 -0.000732422 7.90535 -0.000732422C16.6518 -0.000732422 25.3983 -0.000732422 34.1422 -0.000732422C38.9335 -0.000732422 41.9975 3.04905 42 7.82371C42 25.9424 42.0025 44.0611 42 62.1773C42 66.9445 38.9285 69.9943 34.1347 69.9943C25.3582 69.9943 16.5817 69.9968 7.80522 69.9943C3.07903 69.9943 0.00500656 66.932 0.00250328 62.2148C-0.00250328 53.108 0.00250328 44.0036 0.00250328 34.8968L0 34.8993ZM10.1433 2.61908C9.28716 2.61908 8.57373 2.61908 7.85779 2.61908C4.5084 2.62158 2.62594 4.48645 2.62594 7.81621C2.62594 25.9349 2.62594 44.0511 2.62594 62.1698C2.62594 65.5046 4.5084 67.377 7.85028 67.377C16.5342 67.377 25.2155 67.377 33.8994 67.377C37.5742 67.377 39.3791 65.5921 39.3791 61.9473C39.3791 43.9861 39.3791 26.0249 39.3791 8.06369C39.3791 7.72122 39.3866 7.37624 39.3691 7.03377C39.2639 5.1514 38.0348 3.35903 36.2199 2.92156C34.8331 2.58908 33.3537 2.63908 31.8567 2.51409C31.8567 3.31653 31.8843 3.87899 31.8517 4.43645C31.729 6.5788 30.1044 8.19868 27.9591 8.21118C23.3055 8.24368 18.6519 8.24618 13.9983 8.21118C11.8605 8.19368 10.2334 6.5238 10.1508 4.39645C10.1283 3.84149 10.1483 3.28653 10.1483 2.61658L10.1433 2.61908ZM29.2007 2.68408H12.7642C12.7642 2.96406 12.7642 3.17904 12.7642 3.39403C12.7492 5.31639 13.0371 5.60637 14.9621 5.60637C18.9198 5.60637 22.88 5.60637 26.8376 5.60637C29.0355 5.60637 29.2884 5.34639 29.2358 3.12154C29.2333 2.99905 29.2158 2.87656 29.1982 2.68408H29.2007Z"
          fill="url(#paint0_linear_261_486)"
        />
        <path
          d="M21 61.1549C23.5583 61.1549 26.1192 61.1499 28.6775 61.1549C29.7815 61.1574 30.3748 61.6249 30.3698 62.4523C30.3648 63.2697 29.7515 63.7672 28.67 63.7672C23.5508 63.7747 18.4341 63.7747 13.3149 63.7672C12.226 63.7672 11.6277 63.2747 11.6302 62.4423C11.6302 61.5999 12.196 61.1574 13.3224 61.1549C15.8808 61.1474 18.4416 61.1549 21 61.1549Z"
          fill="url(#paint1_linear_261_486)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_486"
          x1="20.3705"
          y1="-0.000735755"
          x2="20.3705"
          y2="69.9954"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_486"
          x1="20.7189"
          y1="61.1516"
          x2="20.7189"
          y2="63.7728"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_486">
          <rect
            width="42"
            height="70"
            fill="white"
            transform="translate(0 -0.000732422)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons4(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
    >
      <g clipPath="url(#clip0_261_490)">
        <path
          d="M47.44 42.8793C49.12 41.7493 50.36 39.9993 50.82 37.9393L51.81 33.4593C52.13 32.0293 52.83 30.7093 53.84 29.6493L75.94 6.48926"
          stroke="url(#paint0_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M70.99 2.09924L47.63 25.4592C46.6 26.4892 45.15 26.9792 43.7 26.7892L8.73999 22.1992C6.74999 21.9392 4.76999 22.6992 3.46999 24.2192C1.97999 25.9692 1.62999 28.4292 2.58999 30.5192L7.72999 41.7692C8.52999 43.5092 9.80999 44.9792 11.42 46.0192C13.39 47.2792 15.75 47.8092 18.07 47.5092"
          stroke="url(#paint1_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M52.15 20.9293L57.41 25.9093"
          stroke="url(#paint2_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M13.13 75.8993C13.13 75.8993 12.64 72.0993 10.33 70.1593C10.33 70.1593 14.14 70.7693 17.75 74.3393C17.75 74.3393 19.4 66.4993 17.87 62.8593C17.87 62.8593 24.13 68.7593 23.18 75.4093"
          stroke="url(#paint3_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.4 62.8093C29.82 63.8193 30.69 65.0293 30.69 65.0293L31 67.0893C31.08 67.6093 31.13 68.1293 31.17 68.6593C31.22 69.3693 31.35 70.1893 31.48 70.9393C31.73 72.3693 32.2 73.7493 32.86 75.0393L33.06 75.4293L33.26 75.0393C33.92 73.7493 34.39 72.3693 34.64 70.9393C34.77 70.1893 34.89 69.3693 34.95 68.6593C34.99 68.1393 35.04 67.6093 35.12 67.0893L35.43 65.0293C35.43 65.0293 36.3 63.8193 37.72 62.8093C38.02 62.5993 37.87 62.1193 37.5 62.1193H28.63C28.26 62.1193 28.1 62.5993 28.41 62.8093H28.4Z"
          stroke="url(#paint4_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.06 62.1092C41.0516 62.1092 47.53 55.6308 47.53 47.6393C47.53 39.6477 41.0516 33.1693 33.06 33.1693C25.0684 33.1693 18.59 39.6477 18.59 47.6393C18.59 55.6308 25.0684 62.1092 33.06 62.1092Z"
          stroke="url(#paint5_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M28.56 39.2393C27.86 38.8493 26.95 38.9493 26.35 39.5493C25.75 40.1493 25.65 41.0493 26.04 41.7593"
          stroke="url(#paint6_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M26.87 46.0792C26.17 45.6892 25.26 45.7892 24.66 46.3892C24.06 46.9892 23.96 47.8892 24.35 48.5992"
          stroke="url(#paint7_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M33.09 44.6992C32.39 44.3092 31.48 44.4092 30.88 45.0092C30.28 45.6092 30.18 46.5092 30.57 47.2192"
          stroke="url(#paint8_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M35.08 38.3892C34.38 37.9992 33.47 38.0992 32.87 38.6992C32.27 39.2992 32.17 40.1992 32.56 40.9092"
          stroke="url(#paint9_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.51 67.1892C45.65 66.3792 45.87 65.5492 46.2 64.7192C46.2 64.7192 40.81 68.5892 40.37 75.0092"
          stroke="url(#paint10_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M46.2 75.0092C46.2 75.0092 44.77 71.4692 45.51 67.1892"
          stroke="url(#paint11_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M45.44 71.8292C45.44 71.8292 45.59 70.5092 46.7 69.3792C48.21 67.8492 49.81 67.1892 49.81 67.1892C49.81 67.1892 47.94 72.3492 50.3 75.0092"
          stroke="url(#paint12_linear_261_490)"
          strokeWidth="2.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_490"
          x1="61.2625"
          y1="6.48926"
          x2="61.2625"
          y2="42.8793"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_490"
          x1="35.4878"
          y1="2.09924"
          x2="35.4878"
          y2="47.5912"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_490"
          x1="54.7011"
          y1="20.9293"
          x2="54.7011"
          y2="25.9093"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_490"
          x1="16.6098"
          y1="62.8593"
          x2="16.6098"
          y2="75.8993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_490"
          x1="32.9183"
          y1="62.1193"
          x2="32.9183"
          y2="75.4293"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_490"
          x1="32.6259"
          y1="33.1692"
          x2="32.6259"
          y2="62.1092"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_490"
          x1="27.1426"
          y1="39.0071"
          x2="27.1426"
          y2="41.7593"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_490"
          x1="25.4526"
          y1="45.847"
          x2="25.4526"
          y2="48.5992"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_261_490"
          x1="31.6726"
          y1="44.467"
          x2="31.6726"
          y2="47.2192"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_261_490"
          x1="33.6626"
          y1="38.157"
          x2="33.6626"
          y2="40.9092"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_261_490"
          x1="43.1975"
          y1="64.7192"
          x2="43.1975"
          y2="75.0092"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_261_490"
          x1="45.7352"
          y1="67.1892"
          x2="45.7352"
          y2="75.0092"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_261_490"
          x1="47.7971"
          y1="67.1892"
          x2="47.7971"
          y2="75.0092"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_490">
          <rect
            width="76.38"
            height="76.3"
            fill="white"
            transform="translate(0.809998 0.849243)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons5(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="56"
      height="64"
      viewBox="0 0 56 64"
      fill="none"
    >
      <g clipPath="url(#clip0_261_505)">
        <path
          d="M1.5 62.9993H20.5C20.7761 62.9993 21 62.7754 21 62.4993V56.4993C21 56.2231 20.7761 55.9993 20.5 55.9993H1.5C1.22386 55.9993 1 56.2231 1 56.4993V62.4993C1 62.7754 1.22386 62.9993 1.5 62.9993Z"
          stroke="url(#paint0_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.5 55.9993H22.5C22.7761 55.9993 23 55.7754 23 55.4993V49.4993C23 49.2231 22.7761 48.9993 22.5 48.9993H3.5C3.22386 48.9993 3 49.2231 3 49.4993V55.4993C3 55.7754 3.22386 55.9993 3.5 55.9993Z"
          stroke="url(#paint1_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M1.5 48.9993H20.5C20.7761 48.9993 21 48.7754 21 48.4993V42.4993C21 42.2231 20.7761 41.9993 20.5 41.9993H1.5C1.22386 41.9993 1 42.2231 1 42.4993V48.4993C1 48.7754 1.22386 48.9993 1.5 48.9993Z"
          stroke="url(#paint2_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M49.5 55.9993H30.5C30.2239 55.9993 30 56.2231 30 56.4993V62.4993C30 62.7754 30.2239 62.9993 30.5 62.9993H49.5C49.7761 62.9993 50 62.7754 50 62.4993V56.4993C50 56.2231 49.7761 55.9993 49.5 55.9993Z"
          stroke="url(#paint3_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M51.5 48.9993H32.5C32.2239 48.9993 32 49.2231 32 49.4993V55.4993C32 55.7754 32.2239 55.9993 32.5 55.9993H51.5C51.7761 55.9993 52 55.7754 52 55.4993V49.4993C52 49.2231 51.7761 48.9993 51.5 48.9993Z"
          stroke="url(#paint4_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 27.9993H5.5C5.22 27.9993 5 28.2193 5 28.4993V34.4993C5 34.7793 5.22 34.9993 5.5 34.9993H22"
          stroke="url(#paint5_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M55 19.9993H49V0.999268H55"
          stroke="url(#paint6_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10 27.9993V17.3593C10 16.4793 10.29 15.6193 10.83 14.9193L18.5 4.94927C19.45 3.71927 20.91 2.99927 22.46 2.99927H49"
          stroke="url(#paint7_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17 27.9993V19.9993L21 14.9993H27C28.1 14.9993 29 15.8993 29 16.9993V20.9993L21.72 29.2593C20.31 30.9493 20.53 33.4793 22.21 34.8993C23.9 36.3093 26.43 36.0893 27.85 34.4093L36 25.0093C39 25.0093 44 23.0093 46 17.0093H49"
          stroke="url(#paint8_linear_261_505)"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_505"
          x1="11.3"
          y1="62.9993"
          x2="11.3"
          y2="55.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_505"
          x1="13.3"
          y1="55.9993"
          x2="13.3"
          y2="48.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_505"
          x1="11.3"
          y1="48.9993"
          x2="11.3"
          y2="41.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_505"
          x1="39.7"
          y1="55.9993"
          x2="39.7"
          y2="62.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_505"
          x1="41.7"
          y1="48.9993"
          x2="41.7"
          y2="55.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_505"
          x1="13.245"
          y1="27.9993"
          x2="13.245"
          y2="34.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_505"
          x1="51.91"
          y1="0.999267"
          x2="51.91"
          y2="19.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_505"
          x1="28.915"
          y1="2.99927"
          x2="28.915"
          y2="27.9993"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_261_505"
          x1="32.52"
          y1="14.9993"
          x2="32.52"
          y2="35.8283"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_505">
          <rect y="-0.000732422" width="56" height="64" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons6(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="86"
      height="76"
      viewBox="0 0 86 76"
      fill="none"
    >
      <g clipPath="url(#clip0_261_320)">
        <path
          d="M4.11707 74.1905C7.13728 74.1905 10.1394 70.5714 13.1596 70.5714C16.1798 70.5714 19.182 74.1905 22.2022 74.1905C25.2224 74.1905 28.2245 70.5714 31.2447 70.5714C34.2649 70.5714 37.2671 74.1905 40.2873 74.1905C43.3075 74.1905 46.3096 70.5714 49.3298 70.5714C52.35 70.5714 55.3522 74.1905 58.3724 74.1905C61.3926 74.1905 64.3947 70.5714 67.4149 70.5714C70.4352 70.5714 73.4373 74.1905 76.4575 74.1905C79.4777 74.1905 82.4798 70.5714 85.5 70.5714"
          stroke="url(#paint0_linear_261_320)"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M60.1809 66.0295C62.8575 64.0028 64.7203 61.4152 65.6064 59.7142H14.9681L18.5852 65.1428"
          stroke="url(#paint1_linear_261_320)"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M11.3511 3.61902C16.3787 3.61902 20.3936 6.69521 20.3936 10.8571C20.3936 6.69521 24.4085 3.61902 29.4362 3.61902"
          stroke="url(#paint2_linear_261_320)"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M0.5 21.7142C5.52766 21.7142 9.54255 24.7904 9.54255 28.9523C9.54255 24.7904 13.5574 21.7142 18.5851 21.7142"
          stroke="url(#paint3_linear_261_320)"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M56.5638 59.7143L34.8617 18.0952V59.7143"
          stroke="url(#paint4_linear_261_320)"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M34.8618 30.762L20.05 59.7143"
          stroke="url(#paint5_linear_261_320)"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M67.415 25.3334C71.4102 25.3334 74.649 22.0928 74.649 18.0953C74.649 14.0978 71.4102 10.8572 67.415 10.8572C63.4197 10.8572 60.1809 14.0978 60.1809 18.0953C60.1809 22.0928 63.4197 25.3334 67.415 25.3334Z"
          stroke="url(#paint6_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M67.4149 0V5.42857"
          stroke="url(#paint7_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M54.6287 5.30188L58.4627 9.13807"
          stroke="url(#paint8_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M49.3298 18.0952H54.7554"
          stroke="url(#paint9_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M54.6287 30.8886L58.4627 27.0524"
          stroke="url(#paint10_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M67.4149 36.1905V30.762"
          stroke="url(#paint11_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M80.2011 30.8886L76.3671 27.0524"
          stroke="url(#paint12_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M85.5 18.0952H80.0745"
          stroke="url(#paint13_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <path
          d="M80.2011 5.30188L76.3671 9.13807"
          stroke="url(#paint14_linear_261_320)"
          strokeWidth="2"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_320"
          x1="43.5878"
          y1="70.5714"
          x2="43.5878"
          y2="74.1905"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_320"
          x1="39.5277"
          y1="59.7142"
          x2="39.5277"
          y2="66.0295"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_320"
          x1="20.1224"
          y1="3.61902"
          x2="20.1224"
          y2="10.8571"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_320"
          x1="9.27128"
          y1="21.7142"
          x2="9.27128"
          y2="28.9523"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_320"
          x1="45.3872"
          y1="18.0952"
          x2="45.3872"
          y2="59.7143"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_320"
          x1="27.2337"
          y1="30.762"
          x2="27.2337"
          y2="59.7143"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_320"
          x1="67.1979"
          y1="10.8572"
          x2="67.1979"
          y2="25.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_320"
          x1="67.8999"
          y1="-2.58499e-07"
          x2="67.8999"
          y2="5.42857"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_261_320"
          x1="56.4882"
          y1="5.30188"
          x2="56.4882"
          y2="9.13807"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_261_320"
          x1="51.9612"
          y1="18.0952"
          x2="51.9612"
          y2="19.0952"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_261_320"
          x1="56.4882"
          y1="27.0524"
          x2="56.4882"
          y2="30.8886"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_261_320"
          x1="67.8999"
          y1="30.762"
          x2="67.8999"
          y2="36.1905"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint12_linear_261_320"
          x1="78.2266"
          y1="27.0524"
          x2="78.2266"
          y2="30.8886"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint13_linear_261_320"
          x1="82.7058"
          y1="18.0952"
          x2="82.7058"
          y2="19.0952"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint14_linear_261_320"
          x1="78.2266"
          y1="5.30188"
          x2="78.2266"
          y2="9.13807"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_320">
          <rect
            width="85"
            height="76"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons7(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="72"
      height="70"
      viewBox="0 0 72 70"
      fill="none"
    >
      <g clipPath="url(#clip0_261_337)">
        <path
          d="M56.915 28.9921C56.915 28.9921 65.098 32.0091 66.926 34.3751C70.89 39.5061 70.417 50.7111 69.468 56.7901C68.679 61.8451 70.286 68.1371 70.286 68.1371"
          stroke="url(#paint0_linear_261_337)"
          strokeWidth="2.143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M59.147 40.495C56.521 36.39 53.577 36.051 51.562 33.36C47.638 28.118 48.025 28.514 44.421 23.747C42.281 20.917 40.794 19.217 38.003 20.508C35.659 21.592 35.6 23.452 36.312 25.934C37.181 28.962 42.714 39.078 43.844 41.424C44.087 41.929 44.192 42.48 44.146 43.039C43.896 46.061 43.375 54.654 54.356 59.611"
          stroke="url(#paint1_linear_261_337)"
          strokeWidth="2.143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M39.194 47.8051C39.194 58.4001 48.387 60.5751 49.952 68.138"
          stroke="url(#paint2_linear_261_337)"
          strokeWidth="2.143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M42.693 39.1681C36.374 44.9541 30.084 48.8161 29.557 49.1361L28.886 49.5431L28.215 49.1361C27.133 48.4801 1.71399 32.8651 1.71399 16.3291C1.71399 8.35208 8.20499 1.86108 16.182 1.86108C21.547 1.86108 26.393 4.84208 28.886 9.40608C31.379 4.84208 36.225 1.86108 41.59 1.86108C49.568 1.86108 56.058 8.35108 56.058 16.3291C56.058 21.5541 53.52 26.6871 50.014 31.2851"
          stroke="url(#paint3_linear_261_337)"
          strokeWidth="2.143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M41.59 10.7581C44.662 10.7581 47.161 13.2571 47.161 16.3291"
          stroke="url(#paint4_linear_261_337)"
          strokeWidth="2.143"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_337"
          x1="63.3999"
          y1="28.9921"
          x2="63.3999"
          y2="68.1371"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_337"
          x1="47.1812"
          y1="20.0692"
          x2="47.1812"
          y2="59.611"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_337"
          x1="44.4116"
          y1="47.8051"
          x2="44.4116"
          y2="68.1381"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_337"
          x1="28.0708"
          y1="1.86108"
          x2="28.0708"
          y2="49.5431"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_337"
          x1="44.2919"
          y1="10.7581"
          x2="44.2919"
          y2="16.3291"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_337">
          <rect
            width="70.714"
            height="68.42"
            fill="white"
            transform="translate(0.643005 0.790039)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons8(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
    >
      <g clipPath="url(#clip0_261_344)">
        <mask
          id="mask0_261_344"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="76"
          height="76"
        >
          <path
            d="M75.5001 0.546875H0.59375V75.4531H75.5001V0.546875Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_261_344)">
          <path
            d="M11.0807 35.6592C14.3288 35.6592 16.962 33.0391 16.962 29.8071C16.962 26.5751 14.3288 23.9551 11.0807 23.9551C7.8325 23.9551 5.19934 26.5751 5.19934 29.8071C5.19934 33.0391 7.8325 35.6592 11.0807 35.6592Z"
            stroke="url(#paint0_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.2261 49.6163C19.5955 49.0984 20.4909 47.7934 20.4909 46.3363V45.0225C20.4909 38 16.1808 35.6592 12.023 35.6592H10.1415C5.98363 35.6592 1.67358 38 1.67358 45.0225V46.3363C1.67358 47.7934 2.56895 49.0984 3.93833 49.6163C5.55935 50.2279 7.99673 50.8745 11.0837 50.8745C14.1707 50.8745 16.608 50.2308 18.2291 49.6163H18.2261Z"
            stroke="url(#paint1_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M38.0938 59.0674C41.342 59.0674 43.9752 56.4473 43.9752 53.2153C43.9752 49.9833 41.342 47.3633 38.0938 47.3633C34.8457 47.3633 32.2125 49.9833 32.2125 53.2153C32.2125 56.4473 34.8457 59.0674 38.0938 59.0674Z"
            stroke="url(#paint2_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.2393 73.0245C46.6086 72.5066 47.504 71.2016 47.504 69.7445V68.4307C47.504 61.4082 43.194 59.0674 39.0361 59.0674H37.1546C32.9967 59.0674 28.6867 61.4082 28.6867 68.4307V69.7445C28.6867 71.2016 29.5821 72.5066 30.9515 73.0245C32.5725 73.6361 35.0099 74.2827 38.0968 74.2827C41.1838 74.2827 43.6212 73.639 45.2422 73.0245H45.2393Z"
            stroke="url(#paint3_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M38.0938 13.4214C41.342 13.4214 43.9752 10.8013 43.9752 7.56934C43.9752 4.33734 41.342 1.71729 38.0938 1.71729C34.8457 1.71729 32.2125 4.33734 32.2125 7.56934C32.2125 10.8013 34.8457 13.4214 38.0938 13.4214Z"
            stroke="url(#paint4_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M45.2393 27.3785C46.6086 26.8606 47.504 25.5556 47.504 24.0985V22.7847C47.504 15.7622 43.194 13.4214 39.0361 13.4214H37.1546C32.9967 13.4214 28.6867 15.7622 28.6867 22.7847V24.0985C28.6867 25.5556 29.5821 26.8606 30.9515 27.3785C32.5725 27.9901 35.0099 28.6367 38.0968 28.6367C41.1838 28.6367 43.6212 27.993 45.2422 27.3785H45.2393Z"
            stroke="url(#paint5_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M64.9196 35.6592C68.1677 35.6592 70.8009 33.0391 70.8009 29.8071C70.8009 26.5751 68.1677 23.9551 64.9196 23.9551C61.6714 23.9551 59.0382 26.5751 59.0382 29.8071C59.0382 33.0391 61.6714 35.6592 64.9196 35.6592Z"
            stroke="url(#paint6_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M72.065 49.6163C73.4344 49.0984 74.3298 47.7934 74.3298 46.3363V45.0225C74.3298 38 70.0197 35.6592 65.8618 35.6592H63.9804C59.8225 35.6592 55.5125 38 55.5125 45.0225V46.3363C55.5125 47.7934 56.4078 49.0984 57.7772 49.6163C59.3982 50.2279 61.8356 50.8745 64.9226 50.8745C68.0095 50.8745 70.4469 50.2308 72.0679 49.6163H72.065Z"
            stroke="url(#paint7_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M62.087 56.2701C59.436 59.8662 55.9979 62.8478 52.0244 64.9575"
            stroke="url(#paint8_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M14.9341 19.7035C18.1118 15.8178 22.2521 12.7542 26.9893 10.864"
            stroke="url(#paint9_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.0692 64.9546C20.0957 62.8449 16.6576 59.8662 14.0066 56.2672"
            stroke="url(#paint10_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M49.1015 10.864C53.8387 12.7542 57.979 15.8178 61.1567 19.7035"
            stroke="url(#paint11_linear_261_344)"
            strokeWidth="2.34082"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_344"
          x1="10.9042"
          y1="23.9551"
          x2="10.9042"
          y2="35.6592"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_344"
          x1="10.8"
          y1="35.6592"
          x2="10.8"
          y2="50.8745"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_344"
          x1="37.9174"
          y1="47.3633"
          x2="37.9174"
          y2="59.0674"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_344"
          x1="37.8131"
          y1="59.0674"
          x2="37.8131"
          y2="74.2827"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_344"
          x1="37.9174"
          y1="1.71728"
          x2="37.9174"
          y2="13.4214"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_344"
          x1="37.8131"
          y1="13.4214"
          x2="37.8131"
          y2="28.6367"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_344"
          x1="64.7431"
          y1="23.9551"
          x2="64.7431"
          y2="35.6592"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_344"
          x1="64.6388"
          y1="35.6592"
          x2="64.6388"
          y2="50.8745"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_261_344"
          x1="56.9047"
          y1="56.2701"
          x2="56.9047"
          y2="64.9575"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_261_344"
          x1="20.7809"
          y1="10.864"
          x2="20.7809"
          y2="19.7035"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_261_344"
          x1="18.887"
          y1="56.2672"
          x2="18.887"
          y2="64.9546"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint11_linear_261_344"
          x1="54.9483"
          y1="10.864"
          x2="54.9483"
          y2="19.7035"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_344">
          <rect
            width="75"
            height="74.9063"
            fill="white"
            transform="translate(0.5 0.546875)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons9(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="76"
      height="68"
      viewBox="0 0 76 68"
      fill="none"
    >
      <g clipPath="url(#clip0_261_364)">
        <path
          d="M74.8125 0.5H10.6875C10.0314 0.5 9.5 1.0354 9.5 1.69643V61.5179C9.5 63.4979 7.90281 65.1071 5.9375 65.1071C3.97219 65.1071 2.375 63.4979 2.375 61.5179V10.0714C2.375 9.4104 1.84359 8.875 1.1875 8.875C0.531406 8.875 0 9.4104 0 10.0714V61.5179C0 64.817 2.66297 67.5 5.9375 67.5H70.0625C73.337 67.5 76 64.817 76 61.5179V1.69643C76 1.0354 75.4686 0.5 74.8125 0.5ZM73.625 61.5179C73.625 63.4979 72.0278 65.1071 70.0625 65.1071H10.6845C11.4327 64.1081 11.875 62.8638 11.875 61.5179V2.89286H73.625V61.5179Z"
          fill="url(#paint0_linear_261_364)"
        />
        <path
          d="M5.93759 62.7143C6.59369 62.7143 7.12509 62.1789 7.12509 61.5179V6.4822C7.12509 5.82117 6.59369 5.28577 5.93759 5.28577C5.2815 5.28577 4.75009 5.82117 4.75009 6.4822V61.5179C4.75009 62.1789 5.2815 62.7143 5.93759 62.7143Z"
          fill="url(#paint1_linear_261_364)"
        />
        <path
          d="M17.8126 45.9643H36.8126C37.4687 45.9643 38.0001 45.4289 38.0001 44.7679V23.2322C38.0001 22.5712 37.4687 22.0358 36.8126 22.0358H17.8126C17.1565 22.0358 16.6251 22.5712 16.6251 23.2322V44.7679C16.6251 45.4289 17.1565 45.9643 17.8126 45.9643ZM19.0001 24.4286H35.6251V43.5715H19.0001V24.4286Z"
          fill="url(#paint2_linear_261_364)"
        />
        <path
          d="M17.8126 10.0714H67.6876C68.3437 10.0714 68.8751 9.53604 68.8751 8.87502C68.8751 8.21399 68.3437 7.67859 67.6876 7.67859H17.8126C17.1565 7.67859 16.6251 8.21399 16.6251 8.87502C16.6251 9.53604 17.1565 10.0714 17.8126 10.0714Z"
          fill="url(#paint3_linear_261_364)"
        />
        <path
          d="M17.8126 17.25H67.6876C68.3437 17.25 68.8751 16.7146 68.8751 16.0536C68.8751 15.3926 68.3437 14.8572 67.6876 14.8572H17.8126C17.1565 14.8572 16.6251 15.3926 16.6251 16.0536C16.6251 16.7146 17.1565 17.25 17.8126 17.25Z"
          fill="url(#paint4_linear_261_364)"
        />
        <path
          d="M17.8126 53.1429H67.6876C68.3437 53.1429 68.8751 52.6075 68.8751 51.9464C68.8751 51.2854 68.3437 50.75 67.6876 50.75H17.8126C17.1565 50.75 16.6251 51.2854 16.6251 51.9464C16.6251 52.6075 17.1565 53.1429 17.8126 53.1429Z"
          fill="url(#paint5_linear_261_364)"
        />
        <path
          d="M67.6876 22.0358H43.9376C43.2815 22.0358 42.7501 22.5712 42.7501 23.2322C42.7501 23.8932 43.2815 24.4286 43.9376 24.4286H67.6876C68.3437 24.4286 68.8751 23.8932 68.8751 23.2322C68.8751 22.5712 68.3437 22.0358 67.6876 22.0358Z"
          fill="url(#paint6_linear_261_364)"
        />
        <path
          d="M67.6876 29.2142H43.9376C43.2815 29.2142 42.7501 29.7496 42.7501 30.4107C42.7501 31.0717 43.2815 31.6071 43.9376 31.6071H67.6876C68.3437 31.6071 68.8751 31.0717 68.8751 30.4107C68.8751 29.7496 68.3437 29.2142 67.6876 29.2142Z"
          fill="url(#paint7_linear_261_364)"
        />
        <path
          d="M67.6876 36.3928H43.9376C43.2815 36.3928 42.7501 36.9282 42.7501 37.5893C42.7501 38.2503 43.2815 38.7857 43.9376 38.7857H67.6876C68.3437 38.7857 68.8751 38.2503 68.8751 37.5893C68.8751 36.9282 68.3437 36.3928 67.6876 36.3928Z"
          fill="url(#paint8_linear_261_364)"
        />
        <path
          d="M67.6876 43.5714H43.9376C43.2815 43.5714 42.7501 44.1068 42.7501 44.7678C42.7501 45.4289 43.2815 45.9643 43.9376 45.9643H67.6876C68.3437 45.9643 68.8751 45.4289 68.8751 44.7678C68.8751 44.1068 68.3437 43.5714 67.6876 43.5714Z"
          fill="url(#paint9_linear_261_364)"
        />
        <path
          d="M67.6876 57.9286H43.9376C43.2815 57.9286 42.7501 58.464 42.7501 59.125C42.7501 59.786 43.2815 60.3214 43.9376 60.3214H67.6876C68.3437 60.3214 68.8751 59.786 68.8751 59.125C68.8751 58.464 68.3437 57.9286 67.6876 57.9286Z"
          fill="url(#paint10_linear_261_364)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_364"
          x1="36.86"
          y1="0.499997"
          x2="36.86"
          y2="67.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_364"
          x1="5.90197"
          y1="5.28576"
          x2="5.90197"
          y2="62.7143"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_261_364"
          x1="26.992"
          y1="22.0358"
          x2="26.992"
          y2="45.9643"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_261_364"
          x1="41.9663"
          y1="7.67859"
          x2="41.9663"
          y2="10.0714"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_261_364"
          x1="41.9663"
          y1="14.8572"
          x2="41.9663"
          y2="17.25"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_261_364"
          x1="41.9663"
          y1="50.75"
          x2="41.9663"
          y2="53.1429"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_261_364"
          x1="55.4207"
          y1="22.0358"
          x2="55.4207"
          y2="24.4286"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_261_364"
          x1="55.4207"
          y1="29.2142"
          x2="55.4207"
          y2="31.6071"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_261_364"
          x1="55.4207"
          y1="36.3928"
          x2="55.4207"
          y2="38.7857"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint9_linear_261_364"
          x1="55.4207"
          y1="43.5714"
          x2="55.4207"
          y2="45.9643"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint10_linear_261_364"
          x1="55.4207"
          y1="57.9286"
          x2="55.4207"
          y2="60.3214"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_364">
          <rect
            width="76"
            height="67"
            fill="white"
            transform="translate(0 0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function CustomsIcons10(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="96"
      height="62"
      viewBox="0 0 96 62"
      fill="none"
    >
      <g clipPath="url(#clip0_261_377)">
        <path
          d="M47.9775 0.98999C47.905 0.98999 47.8325 0.99749 47.76 1.00999H43.5C42.6725 0.99749 41.99 1.65999 41.98 2.48999C41.9675 3.31749 42.63 3.99999 43.46 4.00999C43.475 4.00999 43.4875 4.00999 43.5025 4.00999H46.5025V7.04749C24.0175 7.84249 6 26.335 6 49.01C2.7025 49.01 0 51.7125 0 55.01C0 58.3075 2.7025 61.01 6 61.01H90C93.2975 61.01 96 58.3075 96 55.01C96 51.7125 93.2975 49.01 90 49.01C90 39.6725 86.9475 31.0325 81.7875 24.0575C80.1575 21.8525 78.3175 19.8125 76.295 17.97C69.1775 11.4775 59.8 7.40749 49.5 7.04499V4.00999H52.5C53.3275 4.02249 54.01 3.35999 54.02 2.52999C54.0325 1.70249 53.37 1.01999 52.54 1.00999C52.525 1.00999 52.5125 1.00999 52.4975 1.00999H48.23C48.145 0.99499 48.06 0.98999 47.975 0.98999L47.9775 0.98999ZM47.7925 10.0175C47.9325 10.0375 48.0725 10.0375 48.2125 10.0175C58.2575 10.07 67.39 13.91 74.275 20.19C76.1525 21.9025 77.865 23.7975 79.3775 25.845C84.17 32.325 87 40.33 87 49.0125H9C9 27.525 26.3325 10.13 47.7925 10.0175ZM6 52.01H90C91.6875 52.01 93 53.3225 93 55.01C93 56.6975 91.6875 58.01 90 58.01H6C4.3125 58.01 3 56.6975 3 55.01C3 53.3225 4.3125 52.01 6 52.01Z"
          fill="url(#paint0_linear_261_377)"
        />
        <path
          d="M48 14.51C40.7825 14.51 34.065 16.73 28.5225 20.5275C27.84 20.995 27.665 21.93 28.1325 22.6125C28.6 23.295 29.535 23.47 30.2175 23.0025C35.2775 19.535 41.395 17.51 47.9975 17.51C61.3275 17.51 72.7 25.775 77.31 37.45C77.59 38.23 78.4475 38.635 79.2275 38.3575C80.0075 38.0775 80.4125 37.22 80.135 36.44C80.125 36.41 80.1125 36.38 80.1 36.35C75.05 23.5575 62.57 14.5125 48 14.5125V14.51Z"
          fill="url(#paint1_linear_261_377)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_261_377"
          x1="46.56"
          y1="0.989987"
          x2="46.56"
          y2="61.01"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_261_377"
          x1="53.2612"
          y1="14.51"
          x2="53.2612"
          y2="38.4449"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
        <clipPath id="clip0_261_377">
          <rect
            width="96"
            height="60.02"
            fill="white"
            transform="translate(0 0.98999)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}

export function ArrowDown(props) {
  return (
    <svg
      className={props.className || ""}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="55"
      viewBox="0 0 14 55"
      fill="none"
      onClick={props.onClick}
    >
      <path
        d="M7.21678 43.8378V1M7.00944 54C8.63271 54 13.8217 45.6275 12.8886 44.6776C11.9555 43.7278 2.15258 43.637 1.13028 44.6776C0.107989 45.7196 5.38747 54 7.00944 54Z"
        stroke="url(#paint0_linear_294_936)"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_294_936"
          x1="6.82"
          y1="0.999997"
          x2="6.82"
          y2="54"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.0729167" stopColor="#E3A455" />
          <stop offset="0.380208" stopColor="#F6DBA6" />
          <stop offset="0.583333" stopColor="#FFEBC4" />
          <stop offset="1" stopColor="#BA7F3B" />
        </linearGradient>
      </defs>
    </svg>
  );
}
